import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentUser } from '../../../selectors/authentication';
import { TYPES, usersUtil } from '../../../services/utils/users-util';
import ContractorTeamEdit from './ContractorTeamEdit';
import ClientTeamEdit from './ClientTeamEdit';
import GeneralContractorTeamEdit from 'components/admin/team/GeneralContractorTeamEdit';
import ServiceProvidersTeamEdit from 'components/admin/team/ServiceProvidersTeamEdit';

class TeamEdit extends Component {
  render() {
    if (usersUtil.hasType(this.props.currentUser, TYPES.CONTRACTOR)) {
      return <ContractorTeamEdit />;
    } else if (usersUtil.hasType(this.props.currentUser, TYPES.CLIENT)) {
      return <ClientTeamEdit />;
    } else if (
      usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR)
    ) {
      return <GeneralContractorTeamEdit />;
    } else {
      return <ServiceProvidersTeamEdit />;
    }
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
  };
})(TeamEdit);



// WEBPACK FOOTER //
// ./src/components/admin/team/TeamEdit.js